import { css } from '@emotion/react';
import { Link, Stack, styled, Typography } from '@mui/joy';
import { createRootRoute, Link as RouterLink, Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import vzkLogo from '@/assets/logos/vzk.svg?url';

const Logo = styled('img')(
  ({ theme }) => css`
    display: block;
    width: auto;
    height: ${theme.spacing(6)};

    ${theme.breakpoints.up('sm')} {
      height: ${theme.spacing(9)};
    }
  `,
);

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : lazy(() =>
        // eslint-disable-next-line import/no-extraneous-dependencies
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

function RootLayout() {
  return (
    <>
      <Outlet />
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    </>
  );
}

function NotFound() {
  return (
    <Stack
      gap={1.5}
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 4,
        textAlign: 'center',
      }}
    >
      <Logo src={vzkLogo} alt="Verkehrszeichen Kataster Baden-Württemberg" />
      <Typography level="h1">Seite nicht gefunden</Typography>
      <Typography>Die aufgerufene Seite existiert nicht oder wurde verschoben.</Typography>
      <Link component={RouterLink} to="/">
        Zur Startseite
      </Link>
    </Stack>
  );
}

export const Route = createRootRoute({ component: RootLayout, notFoundComponent: NotFound });
